import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ROLE_LABELS = { super_admin: 'Власник', store_admin: 'Адмін', cashier: 'Касир' };

/**
 * Единый каркас авторизованных страниц: бренд, заголовок, профиль, выход.
 * props: title, onBack (если задан — показываем стрелку «назад»), right (доп. кнопки),
 *        wide (широкий контент без max-width страницы — для POS).
 */
export default function AppShell({ title, subtitle, onBack, right, children, wide }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const role = user?.role?.toLowerCase();

  return (
    <div className="shell">
      <header className="shell-top">
        <div className="shell-left">
          {onBack ? (
            <button className="shell-back" onClick={onBack} aria-label="Назад">←</button>
          ) : null}
          <div className="shell-brand" onClick={() => navigate('/dashboard')}>
            <span className="shell-mug">🍺</span>
            <span className="shell-brand-txt">Draft<b>Beer</b></span>
          </div>
          {title ? (
            <div className="shell-title-wrap hide-mobile">
              <span className="shell-divider">/</span>
              <span className="shell-title">{title}</span>
            </div>
          ) : null}
        </div>

        <div className="shell-right">
          {right}
          <div className="shell-user hide-mobile">
            <span className="shell-user-name">{user?.full_name || 'Користувач'}</span>
            <span className="badge badge-amber">{ROLE_LABELS[role] || role}</span>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={logout}>Вийти</button>
        </div>
      </header>

      {title ? (
        <div className="shell-mobile-title only-mobile">
          <h2>{title}</h2>
          {subtitle ? <p className="muted">{subtitle}</p> : null}
        </div>
      ) : null}

      <main className={wide ? 'shell-main-wide' : 'page'}>{children}</main>
    </div>
  );
}
